
// NOTE1: this is the source of truth of payment types for market sites, but there is a separate PaymentTypeEnum still around for LTO.

// NOTE2: The codes for the payments should match one-to-one with the CREW database (see comment block below).
// The one exception to this rule is the WIRE type payments, which have a different database structure.

// TODO: consolidate enum files. There's another PaymentType under ns-util.
let PaymentType = {
    VISA: 0,
    MC: 1, // MASTERCARD
    DISC: 2, // DISCOVER
    AMEX: 3, // AMERICAN_EXPRESS
    AEON: 4, // SWITCH ?
    MPOS: 5, // mPos (Thailand)
    PPAL: 119, // PAYPAL
    PROV: 7,   // Provincial Payment - Used in Venezuela (mispagosprovincial.com)
    WIRE: 8,
    DINC: 9, // DINERS
    COD: 10,
    PROPAY: 14,
    ISRA: 15,
    ARGE: 16, // Argencard
    LCAB: 17, // Cabal
    ITAL: 18, // ItalCred
    TARJ: 19, // Tarjeta Naranja
    TARS: 20, // Tarjeta Shopping
    JCB: 21,
    CUP: 22, // China Union Pay
    ALIP: 23, // ALIPAY
    IDEA: 24, // IDEAL
    // WIRES :: The wires are the only exception to the rule that the codes should match one-to-one with the Crew database (see below)
    VIB_WIRE: 25,
    ACB_WIRE: 26,
    VCB_WIRE: 27,
    AGRIBANK_WIRE: 28,
    // END WIRES
    CR: 29, // NUSKIN_CREDIT
    MAS: 30, // Tarjeta Mas
    SDD: 54, // SEPA
    CEDN: 98, // CEDYNA
    PWEB: 102, // PWEB
    DBS: 103, // DBS (Asia Pay (DBS bank) for SG Installment)
    UOB: 104, // UOB (Asia Pay (UOB bank) for SG Installment)
    MBB: 105, // MBB (Asia Pay (MBB bank) for MY Installment)
    PBB: 106, // PBB (Asia Pay (PBB bank) for MY Installment)
    KBANK: 107, // KBANK (Asia Pay (KBANK bank) for TH Installment)
    BCA: 108, // BCA (SPEED (BCA bank) for ID Installment)
    BDO: 109, // BDO (Asia Pay (BDO bank) for PH Installment)
    DINE: 110, // Payment type for Italy Diner club card
    APVN: 113, // APVN (Asia Pay for VN Installment)
    KLIK: 114,  //BCA KLIK Pay
    CIMB: 115,
    PERMATA: 116, //Permata payment type
    VISD: 117, //Visa debit card for Mexico
    MCD: 118, //Master debit card for Mexico
    UOB_2C2P: 120, // UOB-2C2P (Asia Pay (UOB-2C2P) for SG)
    CITI: 121, // CITI (Asia Pay (CITI bank) for MY Installment)
    HSBC: 122, // HSBC (Asia Pay (HSBC bank) for MY Installment)
    BCAI: 123, // BCA installments
    CENC: 125,
    IDMIR: 128, // MIR card for Russia
    AMIN: 129
};

PaymentType.credit = [
    PaymentType.VISA,
    PaymentType.MC,
    PaymentType.DISC,
    PaymentType.AMEX,
    PaymentType.JCB,
    PaymentType.ISRA,
    PaymentType.DINC,
    PaymentType.LCAB,
    PaymentType.MAS,
    PaymentType.TARJ,
    PaymentType.TARS,
    PaymentType.ARGE,
    PaymentType.CENC,
    PaymentType.ITAL,
    PaymentType.DINE,
    PaymentType.VISD,
    PaymentType.MCD,
    PaymentType.IDMIR
];


PaymentType.zooz = {
    0: "VISA",
    1: "MASTERCARD",
    3: "AMEX",
    9: "DINERS",
    16: "ARGENCARD",
    17: "CABAL",
    19: "NARANJA",
    20: "SHOPPING",
    125: "CENCOSUD"
    /*,
    :"RAPIPAGO",
    "PAGOFACIL",
    "BAPRO",
    :"COBRO_EXPRESS",
    :"RIPSA"*/
};

/*

From the CREW database.

 0    Visa                              CCARD                    VISA                      addPayment
 1    MasterCard                        CCARD                    MC                      addPayment
 2    Discover                          CCARD                    DISC                      addPayment
 3    American Express                  CCARD                    AMEX                      addPayment
 24   IDEAL                             CCARD                    IDEA                      emptyPayment
 25   VIB                               WIRE                       1                      emptyPayment
 26   ACB                               WIRE                       2                      emptyPayment
 27   VCB                               WIRE                       3                      emptyPayment
 8    Wire                              WIRE                     WIRE                      emptyPayment
 9    Diners Club                       CCARD                    DINC                      addPayment
 28   AgriBank                          WIRE                     4                      emptyPayment
 29   Company Credit                    COMPANYCREDIT            CR                      emptyPayment
 13   Direct Debit                      DIRECTDEBIT              DD                      directDebitAddPayment
 15   Isra                              CCARD                    ISRA                      addPayment
 17   Cabal                             CCARD                    LCAB                      addPayment
 16   Argencard                         CCARD                    ARGE                      addPayment
 18   Italcred                          CCARD                    ITAL                      addPayment
 19   Tarjeta Naranja                   CCARD                    TARJ                      addPayment
 20   Tarjeta Shopping                  CCARD                    TARS                      addPayment
 21   JCB (Japan)                       CCARD                    JCB                      addPayment
 22   China Union Pay (CUP)             CCARD                    CUP                      emptyPayment
 23   ALIPAY                            CCARD                    ALIP                      emptyPayment
 5    mPos (Thailand)                   CCARD                    MPOS                      addMPOSPayment
 54   SEPA Direct Debit                 DIRECTDEBIT              SDD                      sepaDirectDebit
 6    Pay Pal    C                      CARD                     PPAL                      addPayPalPayment
 14   Yet To Be Used                    CCARD                    Type 14
 30   Tarjeta Mas                       CCARD                    MAS                      addPayment
 31   ATM                               CCARD                    ATM
 32   American Express-Box              CCARD                    BAME
 33   Diners                            CCARD                    BDIN
 34   Banco de Oro MC                   CCARD                    BDMC
 35   Banco de Oro Visa                 CCARD                    BDVI
 36   EFT Box                           WIRE                     BEFT
 37   BJCB                              CCARD                    BJCB
 38   Local Bank credit card            CCARD                    BLC
 39   TH Local CC Zero                  CCARD                    BLC0
 40   MAS Card-Box                      CCARD                    BMAS
 41   Mastercard-Box                    CCARD                    BMC
 42   Visa-Box                          CCARD                    BVIS
 43   CASH                              CASH                     CASH
 44   CIM2                              CCARD                    CIM2
 45   CIM3                              CCARD                    CIM3
 46   CIV2                              CCARD                    CIV2
 47   CIV3                              CCARD                    CIV3
 48   Check                             CCARD                    CK
 49   CIMB MASTER 6 MTHS                CCARD                    CKM1
 50   CIMB MASTER 12 MTHS               CCARD                    CKM2
 51   CIMB VISA 6 MTHS                  CCARD                    CKV1
 52   CIMB VISA 12 MTHS                 CCARD                    CKV2
 53   Commission Credit                 CCARD                    CMCR
 7    Provincial Payment                CCARD                    PROV                      emptyPayment
 55   CITIBANK MASTER 6 MTHS            CCARD                    CTM1
 56   CITIBANK MASTER 12 MTHS           CCARD                    CTM2
 57   CITIBANK VISA 6 MTHS              CCARD                    CTV1
 58   CITIBANK VISA 12 MTHS             CCARD                    CTV2
 59   HSBC Master 6 mths                CCARD                    HSM1
 60   HSBC Master 12 mths               CCARD                    HSM2
 61   HSBC Master 18 mths               CCARD                    HSM3
 62   HSBC Master 24 mths               CCARD                    HSM4
 63   HSBC Visa 6 mths                  CCARD                    HSV1
 64   HSBC Visa 12 mths                 CCARD                    HSV2
 65   HSBC Visa 18 mths                 CCARD                    HSV3
 66   HSBC Visa 24 mths                 CCARD                    HSV4
 67   INM2                              CCARD                    INM2
 68   INM3                              CCARD                    INM3
 69   INV2                              CCARD                    INV2
 70   INV3                              CCARD                    INV3
 71   KBank MC Box                      CCARD                    KBMC
 72   KBank Visa Box                    CCARD                    KBVS
 73   MAYBANK MASTER 6 MTHS             CCARD                    MBM1
 74   MAYBANK MASTER 12 MTHS            CCARD                    MBM2
 75   MAYBANK VISA 6 MTHS               CCARD                    MBV1
 76   MAYBANK VISA 12 MTHS              CCARD                    MBV2
 77   CITI MC                           CCARD                    MCW
 78   Master via EDC-GPRS               CCARD                    MGPR
 79   Master_K_Bank_GPRS                CCARD                    MKGP
 80   NETS                              CCARD                    NETS
 81   Other Voucher                     COMPANYCREDIT            OVOC
 82   PBB Master 6 mths                 CCARD                    PBM1
 83   PBB Master 12 mths                CCARD                    PBM2
 84   PBB Visa 6 mths                   CCARD                    PBV1
 85   PBB Visa 12 mths                  CCARD                    PBV2
 86   SHOR                              CCARD                    SHOR
 87   SCB Bank MC Box                   CCARD                    SMC
 88   SCB Bank VISA Box                 CCARD                    SVIS
 89   Visa via EDC-GPRS                 CCARD                    VGPR
 90   CITI VISA                         CCARD                    VISW
 91   Visa_K_Bank_GPRS                  CCARD                    VKGP
 92   XMC                               CCARD                    XMC
 93   XVISA                             CCARD                    XVISA
 94   Hong Leong MC 6 months            CCARD                    HLM1
 95   Hong Leong MC 12 months           CCARD                    HLM2
 96   Hong Leong VS 6 months            CCARD                    HLV1
 97   Hong Leong VS 12 months           CCARD                    HLV2
 4    AEON                              CCARD                    AEON
 98   Cedyna                            CCARD                    CEDN                      cedynaPayment
 99   Box                               CCARD                    BOX
 10   BPI-MC                            CCARD                    BPMC
 11   BPI-VISA                          CCARD                    BPVI
 12   BPI-ECC                           CCARD                    BPEC
 102  PWEB                              WIRE                     PWEB                      emptyPayment
 103  DBS                               CCARD                    DBS                       emptyPayment
 104  UOB                               CCARD                    UOB                       emptyPayment
 105  MBB                               CCARD                    MBB                       emptyPayment
 106  PBB                               CCARD                    PBB                       emptyPayment
 107  KBANK                             CCARD                    KBANK                     emptyPayment
 108  BCA                               CCARD                    BCA                       emptyPayment
 109  BDO                               CCARD                    BDO                       emptyPayment
 110  DINE                              CCARD                    DINE

 */
export default PaymentType;
